package com.yendo.mx.ui.components

import androidx.compose.runtime.Composable

@Composable
actual fun solicitarUbicacionGPS(onUbicacionRecibida: (String, Double, Double) -> Unit): () -> Unit {
    return {
        onUbicacionRecibida("Ubicación Web", 19.4326, -99.1332)
    }
}

@Composable
actual fun InyectarGpsSilencioso() {
    // No-op para Web
}
